import { BadgeCheck, BookmarkCheck, Route, SlidersHorizontal, type LucideIcon } from "lucide-react";
type ValueItem = {
  title: string;
  description: string;
  icon: LucideIcon;
};
const VALUE_ITEMS: ValueItem[] = [{
  title: "Curated for Quality",
  description: "Handpicked courses and trusted local insights.",
  icon: BadgeCheck
}, {
  title: "Compare with Confidence",
  description: "Understand price, difficulty, access and more.",
  icon: SlidersHorizontal
}, {
  title: "Save and Organise",
  description: "Build your lists and plan your perfect golf trips.",
  icon: BookmarkCheck
}, {
  title: "Plan with Ease",
  description: "Everything you need for a smoother golf experience.",
  icon: Route
}];
export default function ValuePropositionStrip() {
  return <section id="home-value-strip" data-home-section="value-strip" aria-label="Why use TeeListClub" className="relative z-20 w-full m-0 !bg-[rgba(247,244,236,1)]" style={{
    fontFamily: '"Raleway", Arial, sans-serif'
  }}>
    <div className={["mx-auto w-full max-w-[1480px]", "px-5 pb-8 pt-[68px]", "md:px-8 md:pb-9", "lg:px-12 lg:pb-10 lg:pt-[72px]"].join(" ")}>
      <div className={["grid grid-cols-1", "gap-x-8 gap-y-5", "sm:grid-cols-2", "lg:grid-cols-4", "lg:gap-x-9"].join(" ")}>
        {VALUE_ITEMS.map(({
          title,
          description,
          icon: Icon
        }) => <article key={title} className={["relative flex w-full min-w-0", "items-start gap-4", "px-0 py-3", "lg:min-h-[96px]"].join(" ")}>
              <div className={["flex size-[52px] shrink-0", "items-center justify-center", "text-[#073F31]"].join(" ")}>
                <Icon className="size-[42px]" strokeWidth={1.45} aria-hidden="true" />
              </div>

              <div className="min-w-0 flex-1">
                <h3 className={["text-[18px] font-medium", "leading-[1.22]", "text-[#073F31]", "xl:text-[19px]"].join(" ")} style={{
              fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif'
            }}>
                  {title}
                </h3>

                <p className="mt-1.5 max-w-[240px] font-normal leading-[1.55] text-[#65746D] !text-base">
                  {description}
                </p>
              </div>
            </article>)}
      </div>
    </div>
    </section>;
}